(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/change-password/change-password.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/change-password/change-password.js');
"use strict";


const {
  LOGIN
} = svs.ticket_partner.constants.routes;
const {
  GridRow,
  GridCol
} = svs.ui.ReactGrid;
const {
  HEADER,
  INFO_ONE_TIME_PASSWORD
} = svs.ticket_partner.changePassword.constants.FORMS;
const {
  useEffect
} = React;
const {
  PageWrapper
} = svs.ticket_partner.sharedComponents.pageWrapper;
const ChangePassword = () => {
  const {
    ChangePasswordForm
  } = svs.ticket_partner.changePassword;
  const {
    hasRetailerCorpRole,
    hasOneTimePassword,
    setOneTimePasswordUpdated
  } = svs.ticket_partner.useUserContext();
  const {
    redirectToReturnUrl,
    redirectToKeepReturnUrl
  } = svs.ticket_partner.sharedComponents.hooks.useReturnUrl(LOGIN);
  useEffect(() => {
    if (!hasRetailerCorpRole && !hasOneTimePassword) {
      redirectToKeepReturnUrl(LOGIN);
    }
  }, [hasRetailerCorpRole, hasOneTimePassword, redirectToKeepReturnUrl]);
  const onCancel = () => {
    redirectToReturnUrl();
  };
  const onPasswordChanged = () => {
    setOneTimePasswordUpdated();
    redirectToReturnUrl();
  };
  return React.createElement(PageWrapper, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: {
      col: 4
    },
    md: {
      col: 4
    },
    sm: {
      col: 12
    },
    xl: {
      col: 4
    },
    xs: 12
  }, React.createElement("h1", {
    className: "f-bold"
  }, HEADER), hasOneTimePassword ? React.createElement("span", null, INFO_ONE_TIME_PASSWORD) : null, React.createElement(ChangePasswordForm, {
    onCancel: onCancel,
    onPasswordChanged: onPasswordChanged
  }))));
};
svs.ticket_partner.changePassword.ChangePassword = ChangePassword;

 })(window);